/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { FinnairAirCalendarChangeListResponse } from '../../models/finnair-air-calendar-change-list-response';
import { FinnairCalendarChangeRequest } from '../../models/finnair-calendar-change-request';

export interface FindAirCalendarChange$Params {
  orderId: string;
  hash?: string;
  locale?: string;
      body: FinnairCalendarChangeRequest
}

export function findAirCalendarChange(http: HttpClient, rootUrl: string, params: FindAirCalendarChange$Params, context?: HttpContext): Observable<DapiHttpResponse<FinnairAirCalendarChangeListResponse>> {
  const rb = new DapiRequestBuilder(rootUrl, findAirCalendarChange.PATH, 'post');

  if (params) {
    rb.path('orderId', params.orderId, {});
    rb.query('hash', params.hash, {});
    rb.query('locale', params.locale, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<FinnairAirCalendarChangeListResponse>;
    }),
    catchErrorAsJson()
  );
}

findAirCalendarChange.PATH = '/api/change/{orderId}/calendar';
